const products = [
    {
        'id': '05',
        'name': 'Grease Monkey',
        'image': '/images/zazaa2.png',
        'brand': 'Hybrid',
        'category': 'exotic',
        'description': 'Grease Monkey is an indica-dominant hybrid with a sweet, creamy aroma, delivering a relaxing, euphoric experience.',
        'rating': 5,
        'numReviews': 12,
        'price': 180,
        'countInStock': 10,
    },
    {
        'id': '051',
        'name': 'White Truffle',
        'image': '/images/icek.png',
        'brand': 'Indica',
        'category': 'exotic',
        'description': 'White Truffle is an indica-dominant hybrid with a sweet, creamy aroma, delivering a relaxing, euphoric experience.',
        'rating': 5,
        'numReviews': 12,
        'price': 180,
        'countInStock': 10,
    },
    {
        'id': '01',
        'name': 'Paris Rock Candy',
        'image': '/images/rcc.png',
        'brand': 'Indica',
        'category': 'exotic',
        'description': 'Paris Rock Candy is a smooth, sweet hybrid that combines the fruity, citrusy goodness of Paris OG with the tropical, herbal vibes of Alien Rock Cand.',
        'rating': 5,
        'numReviews': 12,
        'price': 180,
        'countInStock': 10,
    },
    {
        'id': '02',
        'name': 'Blue Nerds',
        'image': '/images/phaze.png',
        'brand': 'Sativa',
        'category': 'exotic',
        'description': 'Blue Nerds Strain is perfect for anyone seeking a flavorful, balanced experience that promotes relaxation while boosting creativity.',
        'rating': 5,
        'numReviews': 12,
        'price': 180,
        'countInStock': 10,
    },{
        'id': '03',
        'name': 'Ice Cream Cake',
        'image': '/images/icek.png',
        'brand': 'Hybrid',
        'category': 'TopShelf flower',
        'description': 'Ice Cream Cake is a rare indica dominant hybrid strain created through a cross of the Gelato 33 X Wedding Cake strains.',
        'rating': 5,
        'numReviews': 12,
        'price': 130,
        'countInStock': 10,
    },
    {
        'id': '04',
        'name': 'Cereal Milk',
        'image': '/images/zookis.png',
        'brand': 'Hybrid',
        'category': 'TopShelf flower',
        'description': 'Cereal Milk is a hybrid strain, offers a smooth mix of uplifting energy and calming relaxation.',
        'rating': 5,
        'numReviews': 12,
        'price': 130,
        'countInStock': 10,
    },
    // {
    //     'id': '1',
    //     'name': 'GG4 (Gorilla Glue #4)',
    //     'image': '/images/bong.PNG',
    //     'brand': 'hybrid',
    //     'category': 'flower',
    //     'description': 'A legendary hybrid strain (60% Indica / 40% Sativa) famous for its ultra-sticky resin and knockout effects',
    //     'rating': 5,
    //     'numReviews': 12,
    //     'price': 100,
    //     'countInStock': 100,
    // },
    // {
    //     'id': '2',
    //     'name': 'Blue Dream',
    //     'image': '/images/bubbler.PNG',
    //     'brand': 'hybrid',
    //     'category': 'flower',
    //     'description': '17-24% THC | Blueberry haze | Gentle cerebral lift + smooth body calm',
    //     'rating': 4.5,
    //     'numReviews': 1,
    //     'price': 100,
    //     'countInStock': 10,
    // },
    // {
    //     'id': '3',
    //     'name': 'Wedding Cake',
    //     'image': '/images/devices.PNG',
    //     'brand': 'hybrid',
    //     'category': 'flower',
    //     'description': '22-27% THC | Vanilla + peppery dough | Happy vibes with muscle-melting relief',
    //     'rating': 5,
    //     'numReviews': 12,
    //     'price': 100,
    //     'countInStock': 100,
    // },
    // {
    //     'id': '4',
    //     'name': 'Gelato',
    //     'image': '/images/pipes.PNG',
    //     'brand': 'hybrid',
    //     'category': 'flower',
    //     'description': 'Instagram’s favorite sweet trea, 20-25% THC | Sweet cream + lavender, Best for: relaxation',
    //     'rating': 4.5,
    //     'numReviews': 1,
    //     'price': 100,
    //     'countInStock': 10,
    // },
    {
        'id': '5',
        'name': 'Northern Lights',
        'image': '/images/pipes.PNG',
        'brand': 'Indica',
        'category': 'flower',
        'description': 'One of the most famous indicas, known for its fast-acting relaxation and stress-melting properties',
        'rating': 5,
        'numReviews': 1,
        'price': 100,
        'countInStock': 10,
    },
    // {
    //     'id': '6',
    //     'name': 'Pinaple Express',
    //     'image': '/images/delta-8-thc-products-1.jpg',
    //     'brand': 'Indica',
    //     'category': 'flower',
    //     'description': 'A potent indica with a sweet, earthy aroma, delivering heavy sedation and pain relief',
    //     'rating': 4,
    //     'numReviews': 1,
    //     'price': 100,
    //     'countInStock': 10,
    // },
    {
        'id': '7',
        'name': 'Zkittle',
        'image': '/images/disposables.jpg',
        'brand': 'Indica',
        'category': 'flower',
        'description': 'A classic indica with sweet grape and berry flavors, known for deep relaxation and stress relief',
        'rating': 5,
        'numReviews': 12,
        'price': 100,
        'countInStock': 100,
    },
    {
        'id': '8',
        'name': 'Sour Diesel',
        'image': '/images/juice.PNG',
        'brand': 'sativa',
        'category': 'flower',
        'description': 'A fast-acting sativa with a pungent diesel-like aroma, known for energizing and uplifting effects',
        'rating': 4.6,
        'numReviews': 1,
        'price': 100,
        'countInStock': 10,
    },
    {
        'id': '9',
        'name': 'Apple Fritter',
        'image': '/images/placeholder.PNG',
        'brand': 'hybrid',
        'category': 'flower',
        'description': 'Apple Fritter is a hybrid  Weed strain that offers a perfect blend of uplifting effects and full-body relaxation',
        'rating': 5,
        'numReviews': 12,
        'price': 100,
        'countInStock': 100,
    },
    {
        'id': '10',
        'name': 'Green Crack',
        'image': '/images/smoke.PNG',
        'brand': 'sativa',
        'category': 'flower',
        'description': 'A potent sativa with tropical fruit flavors, providing intense focus and invigorating energy',
        'rating': 4.2,
        'numReviews': 1,
        'price': 100,
        'countInStock': 10,
    },

    {
        'id': '13',
        'name': 'Raw Garden',
        'image': '/images/rawc.PNG',
        'brand': 'indica',
        'category': 'Cartages',
        'description': 'Raw Garden vape cartridges generally offer a sweet, fruity flavor profile with indica-dominant effects.',
        'rating': 5,
        'numReviews': 12,
        'price': 30,
        'countInStock': 100,
    },
    {
        'id': '14',
        'name': 'MUHA MEDS',
        'image': '/images/muha.PNG',
        'brand': 'Indica',
        'category': 'Cartages',
        'description': 'MUHA MEDS Carts are known for their beneficial effects, including pain relief, stress relief, relaxation, increased energy, euphoria, and depression relief. ',
        'rating': 4.2,
        'numReviews': 1,
        'price': 30,
        'countInStock': 100,
    },
    {
        'id': '15',
        'name': 'Friendly Farms',
        'image': '/images/frc.PNG',
        'brand': 'hybrid',
        'category': 'Cartages',
        'description': 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
        'rating': 5,
        'numReviews': 12,
        'price': 30,
        'countInStock': 100,
    },
    {
        'id': '16',
        'name': 'Friendly Farms',
        'image': '/images/frs.PNG',
        'brand': 'sativa',
        'category': 'Cartages',
        'description': 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
        'rating': 4.2,
        'numReviews': 1,
        'price': 30,
        'countInStock': 100,
    },
    {
        'id': '188',
        'name': 'BOUTIQ SWITCH V5 (3 in 1)',
        'image': '/images/jeee.PNG',
        'brand': '2g Disposable',
        'category': 'Disposable Cart',
        'description': 'BOUTIQ SWITCH V5 offers three unique, freshly crafted flavors in one handy package, enabling effortless transitions between them with each inhale.',
        'rating': 5,
        'numReviews': 11,
        'price': 60,
        'countInStock': 10,
    },
    {
        'id': '87',
        'name': 'PACKWOODS',
        'image': '/images/pacw.PNG',
        'brand': '2g Disposable',
        'category': 'Disposable Cart',
        'description': '2 grams premium THC + live resin + liquid diamonds. We have differet flavors, for more info, Text/Call 202-209-9605.',
        'rating': 5,
        'numReviews': 12,
        'price': 50,
        'countInStock': 10,
    },
    {
        'id': '88',
        'name': ' Drip Dual Flavor',
        'image': '/images/drip.PNG',
        'brand': '2g Disposable',
        'category': 'Disposable Cart',
        'description': 'with two tempting flavors in one 2-gram item, giving a smooth interplay of freshness, strength, and diversity of taste.We have 5 differet flavors, for more info, Text/Call 202-209-9605.',
        'rating': 4.2,
        'numReviews': 1,
        'price': 50,
        'countInStock': 10,
    },
    {
        'id': '187',
        'name': 'MUHA MEDS',
        'image': '/images/muu.PNG',
        'brand': '2g Disposable',
        'category': 'Disposable Cart',
        'description': 'MUHA MEDS 2G Disposable offers strong effects cannabinoid concentration and full-spectrum composition. We have differet flavors, for more info, Text/Call 202-209-9605.',
        'rating': 5,
        'numReviews': 12,
        'price': 50,
        'countInStock': 10,
    },
    // {
    //     'id': '287',
    //     'name': 'Jeeter Live Resin',
    //     'image': '/images/jee.PNG',
    //     'brand': '2g Disposable',
    //     'category': 'Disposable Cart',
    //     'description': 'Made from fresh frozen flower that is flash frozen right after harvest to lock in the natural terpenes and cannabinoids.We have differet flavors, for more info, Text/Call 202-209-9605.',
    //     'rating': 5,
    //     'numReviews': 2,
    //     'price': 50,
    //     'countInStock': 10,
    // },
    {
        'id': '32',
        'name': 'Top-shelf preroll',
        'image': '/images/preroll.PNG',
        'brand': 'pre-rolls',
        'category': 'Prerolls',
        'description': 'Top Shelf 10 x 80, and 20 X 150',
        'rating': 4.2,
        'numReviews': 1,
        'price': 10,
        'countInStock': 10,
    },
    {
        'id': '33',
        'name': 'Premium preroll',
        'image': '/images/prr.PNG',
        'brand': 'Pre-rolls',
        'category': 'Prerolls',
        'description': 'Premium prerolls 10 x 80, and 20 X 150',
        'rating': 5,
        'numReviews': 12,
        'price': 10,
        'countInStock': 100,
    },
    // {
    //     'id': '51',
    //     'name': 'Shatter',
    //     'image': '/images/shaa.PNG',
    //     'brand': '5g shatter',
    //     'category': 'Concentrates',
    //     'description': '5g shatter 50',
    //     'rating': 4.4,
    //     'numReviews': 1,
    //     'price': 50,
    //     'countInStock': 0,
    // },
    // {
    //     'id': '52',
    //     'name': 'Tincture',
    //     'image': '/images/thnc.PNG',
    //     'brand': '1000MG THC Tincture',
    //     'category': 'Concentrates',
    //     'description': 'THC tinctures emerge as an ideal choice for non-smokers or those seeking a discreet and rapidly effective cannabis solution',
    //     'rating': 4.8,
    //     'numReviews': 1,
    //     'price': 50,
    //     'countInStock': 0,
    // },
    {
        'id': '76',
        'name': 'Trolli Gummi Candy',
        'image': '/images/gem.PNG',
        'brand': 'Edible 600 mg',
        'category': 'Edibles',
        'description': 'Gummy worms edibles 5X100',
        'rating': 5,
        'numReviews': 12,
        'price': 25,
        'countInStock': 100,
    },
    {
        'id': '77',
        'name': 'Faded Gummies',
        'image': '/images/fadd.PNG',
        'brand': 'Edible 600 mg',
        'category': 'Edibles',
        'description': 'Faded edibles 5 X 100',
        'rating': 4.9,
        'numReviews': 1,
        'price': 25,
        'countInStock': 10,
    },
    // {
    //     'id': '78',
    //     'name': 'Stony Patch',
    //     'image': '/images/ste.PNG',
    //     'brand': 'Edible 500 mg',
    //     'category': 'Edibles',
    //     'description': 'Stony Patch edibles 6X100',
    //     'rating': 5,
    //     'numReviews': 12,
    //     'price': 25,
    //     'countInStock': 100,
    // },
    {
        'id': '79',
        'name': 'Peach',
        'image': '/images/edibles2.PNG',
        'brand': 'Edible',
        'category': 'Edibles',
        'description': 'Peach ring edibles 5X100',
        'rating': 4.7,
        'numReviews': 1,
        'price': 25,
        'countInStock': 10,
    },
];

export { products };
